import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: 'app-eca-confirm-modal',
  templateUrl: './eca-confirm-modal.component.html',
  styleUrls: ['./eca-confirm-modal.component.scss']
})

export class EcaConfirmModalComponent implements OnInit {
  @Input() question: string;
  @Input() heading: string;
  @Input() yesButtonText = 'Yes';
  @Input() noButtonText = 'No';
  @Input() yesButtonColour = 'success';
  @Input() noButtonColour = 'danger';
  @Input() yesButtonIcon: any = null;
  @Input() noButtonIcon: any = null;

  @Output() answer: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public modalRef: DynamicDialogRef) { }

  ngOnInit() {
  }

  clicked(answer: boolean) {
    this.answer.emit(answer);
    this.modalRef.close();
  }
}
